(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["routine-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoutineGuide(root) {
      var button = root.querySelector('[data-routine-add-all]');
      var message = root.querySelector('[data-routine-message]');
      var totalEl = root.querySelector('[data-routine-total]');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-routine-step]'));
 
      if (!button) return;
 
      function money(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
        });
      }
 
      function updateTotal() {
        if (!totalEl) return;
        var total = steps.reduce(function (sum, el) {
          if (el.dataset.available !== 'true') return sum;
          return sum + (parseInt(el.dataset.price, 10) || 0);
        }, 0);
        totalEl.textContent = total > 0 ? money(total) : '';
      }
 
      function setMessage(text, state) {
        if (!message) return;
        message.textContent = text || '';
        if (state) {
          message.setAttribute('data-state', state);
        } else {
          message.removeAttribute('data-state');
        }
      }
 
      updateTotal();
 
      button.addEventListener('click', function () {
        var items = steps
          .filter(function (el) { return el.dataset.available === 'true'; })
          .map(function (el) { return { id: parseInt(el.dataset.variantId, 10), quantity: 1 }; });
 
        if (!items.length) {
          setMessage('These items are currently unavailable.', 'error');
          return;
        }
 
        button.disabled = true;
        var label = button.querySelector('[data-label]');
        var originalLabel = label ? label.textContent : '';
        if (label) label.textContent = 'Adding…';
        setMessage('', null);
 
        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function (cart) {
            setMessage('Added to your bag.', 'success');
 
            // Cancelable hook so a theme/ajax cart drawer can take over instead
            // of the default redirect below — call event.preventDefault() on
            // this to stop the redirect once you wire up a drawer.
            var evt = new CustomEvent('ambernay:cart-add', {
              bubbles: true,
              cancelable: true,
              detail: { cart: cart }
            });
            var defaultPrevented = !root.dispatchEvent(evt);
 
            // Common theme refresh hooks — harmless if nothing listens.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
 
            if (!defaultPrevented) {
              window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                ? window.Shopify.routes.root
                : '/') + 'cart';
              return;
            }
 
            button.disabled = false;
            if (label) label.textContent = originalLabel;
          })
          .catch(function (err) {
            setMessage((err && err.description) || 'Something went wrong — please try again.', 'error');
            button.disabled = false;
            if (label) label.textContent = originalLabel;
          });
      });
    }
 
    document.querySelectorAll('.routine-guide').forEach(initRoutineGuide);
 
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.routine-guide');
      if (section) initRoutineGuide(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
